import React, { ReactElement } from 'react';
import { Link } from '../../widgets/buttons';
import { T } from 'src/shared/helpers';
import { Model } from '../productConfiguration/state';
import { ModelColor } from '../productConfiguration/state/model/modelColor';
import { ModelSide } from '../productConfiguration/state/model/modelSide';

export function canSideRotationIsAvailable(product: Model, modelSide?: ModelSide | null, modelColor?: ModelColor | null): [boolean, string | ReactElement] {
    const isResizableForSide = product.options.some((x) => x.colorGuid == modelColor?.guid && (x.isResizable || (x.isSplitOutput && x.sideGuid == null)));

    const isResizableForVariant = product.options.some(
        (x) => x.colorGuid == modelColor?.guid && (x.isResizable || (x.isSplitOutput && x.sideGuid == modelSide?.originalSideGuid))
    );

    const isBleedLines = modelSide?.areas.some((z) => z.layers.length > 0);
    const haveArea = modelSide?.areas.length ?? 0;

    if (isBleedLines) {
        return [
            false,
            <>
                {T._(
                    'This option is unavailable because a PDF-layers (OCG) has been loaded on this side to create the area and bleed lines, and they are not compatible. ',
                    'Admin'
                )}
                <br />
                <Link target='_blank' href='https://zakeke.zendesk.com/hc/en-us/articles/11739151453468-Side-rotation-in-UI#h_01HHHFRA9VD4Y3BY39E6ZVQFMT'>
                    {T._('Learn more here', 'Admin')}
                </Link>
            </>
        ];
    } else if (isResizableForSide || isResizableForVariant) {
        return [
            false,
            <>
                {T._(
                    'This option is unavailable because the resizable or multi-canvas option has already been activated on this side, and they are not compatible. ',
                    'Admin'
                )}
                <br />
                <Link target='_blank' href='https://zakeke.zendesk.com/hc/en-us/articles/11739151453468-Side-rotation-in-UI#h_01HHHFRA9VD4Y3BY39E6ZVQFMT'>
                    {T._('Learn more here', 'Admin')}
                </Link>
            </>
        ];
    } else if (haveArea === 0) {
        return [false, T._("To enable this option, please create a print area on this product's side first", 'Admin')];
    } else {
        return [true, ''];
    }
}
